// extracted by mini-css-extract-plugin
module.exports = {"header":"FormGroup_header__fiP_7","childrenContainer":"FormGroup_childrenContainer__lFf3y"};